import { render, staticRenderFns } from "./CatalogRuleOverview.vue?vue&type=template&id=0b38e2f6&scoped=true&"
import script from "./CatalogRuleOverview.vue?vue&type=script&lang=js&"
export * from "./CatalogRuleOverview.vue?vue&type=script&lang=js&"
import style0 from "./CatalogRuleOverview.vue?vue&type=style&index=0&id=0b38e2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b38e2f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDialog,VSpacer,VToolbar,VToolbarTitle})
